import React from "react";
import AppLink from "../components/appLink/AppLink";
import Grid from "../components/grid/Grid";
import Section from "../components/section/Section";

const FourOhFour = () => (
  <article>
    <Section
      header
      largePadding
      padding="both"
    >
      <Grid>
        <div>
          <h1 className="h1Bigger">Four, Oh! Four</h1>
          <p className="largeBodyText">
            Sorry, can&apos;t find the page you&apos;re looking for.
          </p>
          <AppLink to="/" title="Go home" type="arrow">
            Take me home
          </AppLink>
          <br />
          <AppLink to="/what-we-do/" type="arrow">
            What we do
          </AppLink>
          <br />
          <AppLink to="/work/" type="arrow">
            Work
          </AppLink>
          <br />
          <AppLink to="/our-story/" type="arrow">
            Our story
          </AppLink>
          <br />
          <AppLink to="/join-us/" type="arrow">
            Join us
          </AppLink>
          <br />
          <AppLink to="/contact-us/" type="arrow">
            Contact us
          </AppLink>
        </div>
      </Grid>
    </Section>
  </article>
);

export default FourOhFour;
